<template>
  <b-table responsive :items="notifications" :fields="fields" :filter="filter" :filter-function="filterFunction">
    <template slot="HEAD(is_active)" slot-scope="data">
      {{data.label | translate}}
    </template>
    <template slot="HEAD(message)" slot-scope="data">
      {{data.label | translate}}
    </template>
    <div slot="cell(is_active)" slot-scope="data">
     <div class="btn-group btn-group-sm" data-toggle="btn-toggle">
        <button type="button" @click="$emit('edit', data.item)" :class="['btn btn-success btn-sm', data.item.is_active === 1 ? 'active' : '']"><i class="fa fa-check"></i></button>
        <button type="button" @click="$emit('edit', data.item)" :class="['btn btn-danger btn-sm', data.item.is_active === 0 ? 'active' : '']"><i class="fa fa-ban"></i></button>
      </div>
    </div>
    <div slot="cell(message)" slot-scope="data">
      <div :class="['alert', `alert-${data.item.status}`, 'no-margin']">
        <h4><i :class="data.item.icon"></i> {{`alert_${data.item.status}` | translate}}!</h4>
        <span v-html="data.item.original_message"></span>
        <!--<span v-for="line in data.item.message">{{line}} <template v-if="data.item.message.length > 1"><br/></template></span>-->
      </div>
    </div>
    <div slot="cell(delete)" slot-scope="data">
      <button type="button" class="btn btn-app btn-danger" @click="$emit('delete', data.item.id)"><i class="fa fa-trash-o"></i></button>
    </div>
  </b-table>
</template>
<script>
  export default {
    props: ['notifications', 'filter'],
    data () {
      return {
        moment: moment,
        fields: [
          {key: 'is_active', label: 'status'},
          {key: 'message', label: 'report'},
          'delete'
        ]
      }
    },
    methods: {
      filterFunction (row, filter) {
        if (filter === null) {
          return true
        }
        return row.is_active === parseInt(filter)
      }
    },
    watch: {
      model () {
        this.notifications = []
      },
      filter () {}
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tools/Tables/NotificationsTable.vue